<template>
    <v-modal-confirmed accept-button-text="Borrar"
                       close-button-text="Cancelar"
                       title="Borrar entidad"
                       confirm-modal-accept-button-text="Sí"
                       confirm-modal-close-button-text="No"
                       confirm-modal-text="¿Estás seguro?"
                       confirm-modal-title="Confirmar..."
                       @closed="closeModal"
                       @accepted="deleteEntity">
        <span>¿Seguro que quieres eliminar a esta entidad?</span>
        <div class="user-name">{{ entity.name }}</div>
    </v-modal-confirmed>
</template>

<script>
import VModalConfirmed from "../../general/VModalConfirmed";
import {deleteEntity} from "../../../helpers/requests/RequestsEntities";

export default {
    name: "EntitiesListDeleteModal",
    components: {VModalConfirmed},
    props: {
        entity: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async deleteEntity() {
            try {
                await deleteEntity(this.entity);

                this.$store.dispatch('app/setToastMessage', 'Entidad eliminada');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar la entidad');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
